import React, { useEffect, useState } from "react";
import { StyledShopName, StyledTopPart } from "../Catalog/styled";
import {
  Avatar,
  Button,
  Divider,
  Grid,
  IconButton,
  SvgIcon,
  Typography,
} from "@mui/material";
import {
  ArrowBack,
  ArrowForward,
  ConfirmationNumberOutlined,
  FavoriteBorder,
  HelpOutlineOutlined,
  InfoOutlined,
  NavigateBefore,
  NotificationsNoneOutlined,
  Storefront,
} from "@mui/icons-material";
import { colors } from "../../theme/colors";
import { useNavigate, useSearchParams } from "react-router-dom";
import { StyledCardAmount, StyledProductWrapper, StyledTitle } from "./styled";
import { ProductWrapper } from "../Shop/styled";
import { getInitials } from "../../utils/functions";

import { ReactComponent as StoreIcon } from "../../assets/svg/store-default.svg";
import { ReactComponent as NotificationIcon } from "../../assets/svg/notification-active.svg";
import { ReactComponent as TicketIcon } from "../../assets/svg/ticket2-default.svg";
import { ReactComponent as HeartIcon } from "../../assets/svg/Trazado 19268.svg";

export default function Resume({ product, nextStep, va }) {
  const navigate = useNavigate();
  const [buttonHover, setButtonHover] = useState(false);

  return (
    <>
      <div style={{ maxWidth: "85%", margin: "auto" }}>
        <Divider sx={{ marginTop: "1rem", marginBottom: "1rem" }} />

        <Grid container justifyContent="center" spacing={2} alignItems="center">
          <Grid item>
            <IconButton
              onClick={(e) => {
                navigate(`../shop/${product.partnerId}`);
              }}
            >
              <NavigateBefore
                sx={{
                  color: colors.secondary,
                  fontSize: "30px",
                }}
              />
            </IconButton>
          </Grid>
          <Grid item lg={5} sm={7} xl={4}>
            <StyledTitle>Detalles de la compra</StyledTitle>
          </Grid>
        </Grid>

        <StyledProductWrapper container direction="column">
          <Grid item>
            <Grid container textAlign="start">
              <Grid item md={4} textAlign="start">
                {product.brandImage ? (
                  <Avatar
                    sx={{
                      width: 80,
                      height: 80,
                      margin: "0.5rem",
                      "@media screen and (max-width: 600px)": {
                        width: 40,
                        height: 40,
                      },
                    }}
                    src={product.brandImage}
                  />
                ) : (
                  <StyledShopName
                    style={{
                      width: 80,
                      height: 80,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0.5rem auto auto 0.5rem",
                    }}
                  >
                    <span>{getInitials(product.partner)}</span>
                  </StyledShopName>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            {product.productType === "PRODUCT" ? (
              <ProductWrapper hasImage={product.voucherImage} size="150px">
                {product.voucherImage ? (
                  <img
                    src={product.voucherImage}
                    alt={product.voucherName}
                    style={{ maxWidth: "100%" }}
                  />
                ) : (
                  <Storefront
                    sx={{
                      fontSize: { sm: "5rem", xs: "3rem" },
                      color: colors.white.main,
                    }}
                  />
                )}
              </ProductWrapper>
            ) : (
              <StyledCardAmount>
                {"Q "}
                {product.productType === "RANGE_AMOUNT" ? va : product.price}
              </StyledCardAmount>
            )}
            <div style={{ color: colors.white.main, marginTop: "0.5rem" }}>
              {product.voucherName}
            </div>
          </Grid>
        </StyledProductWrapper>
      </div>

      <Grid
        style={{
          color: colors.secondary,
          textTransform: "capitalize",
          textAlign: "center",
          fontSize: "22px",
        }}
        container
        spacing={3}
        justifyContent="center"
      >
        <Grid item>TOTAL A PAGAR:</Grid>
        <Grid item>
          <strong>
            Q
            {product.productType === "RANGE_AMOUNT"
              ? parseFloat(va) + parseFloat(product.fee)
              : parseFloat(product.price) + parseFloat(product.fee)}
          </strong>
        </Grid>
      </Grid>

      {parseFloat(product.fee) > 0 && (
        <Typography
          textAlign="center"
          variant="h5"
          fontWeight="bold"
          fontSize="1.25rem"
        >
          *Aplica costo de envío
        </Typography>
      )}

      <Button
        endIcon={buttonHover ? <ArrowForward color="secondary" /> : null}
        onMouseOver={() => setButtonHover(true)}
        onMouseOut={() => setButtonHover(false)}
        color={buttonHover ? "primary" : "secondary"}
        variant="contained"
        onClick={nextStep}
        sx={{
          left: "50%",
          transform: "translateX(-50%)",
          width: "60%",
          paddingRight: buttonHover ? "10%" : "initial",
          transition: "padding 200ms",
          paddingTop: "0.5rem",
          paddingBottom: "0.5rem",
          marginTop: "1.5rem",
          maxWidth: "650px",
          "@media screen and (max-width: 450px)": {
            width: "85%",
          },
        }}
      >
        Siguiente
      </Button>

      <Grid
        container
        spacing={2}
        columnGap={20}
        sx={{ width: "85%", margin: "auto", marginTop: "3rem" }}
        justifyContent="center"
      >
        {product.description && (
          <Grid
            item
            alignItems="center"
            gap={2}
            sm={12}
            md={4}
            lg={4}
            textAlign="start"
          >
            <div style={{ display: "flex", marginBottom: "2rem" }}>
              <InfoOutlined color="primary" fontSize="large" />
              <Typography variant="h3" marginLeft={"1rem"}>
                ¿Qué incluye?
              </Typography>
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: product.description,
              }}
            />
          </Grid>
        )}
        <Grid
          item
          alignItems="center"
          gap={2}
          sm={12}
          md={4}
          lg={4}
          textAlign="start"
        >
          <div style={{ display: "flex" }}>
            <HelpOutlineOutlined color="primary" fontSize="large" />
            <Typography variant="h3" marginBottom="2rem" marginLeft={"1rem"}>
              ¿Cómo funciona?
            </Typography>
          </div>
          <Grid container spacing={4} direction={"column"}>
            <Grid
              item
              display="flex"
              alignItems="center"
              gap={2}
              sm={12}
              textAlign="start"
            >
              <SvgIcon
                component={NotificationIcon}
                inheritViewBox
                sx={{ fontSize: "40px" }}
              />
              <Typography variant="body1">
                Elige lo que deseas enviarle a tu ser querido de marcas
                reconocidas.
              </Typography>
            </Grid>
            <Grid
              item
              display="flex"
              alignItems="center"
              gap={2}
              sm={12}
              textAlign="start"
            >
              <SvgIcon
                component={TicketIcon}
                inheritViewBox
                sx={{ fontSize: "40px" }}
              />
              <Typography variant="body1">
                Paga con tarjeta de crédito o débito a través de Ecosistema Bi.
              </Typography>
            </Grid>
            <Grid
              item
              display="flex"
              alignItems="center"
              gap={2}
              sm={12}
              textAlign="start"
            >
              <SvgIcon
                component={HeartIcon}
                inheritViewBox
                sx={{ fontSize: "40px" }}
              />
              <Typography variant="body1">
                Enviamos el vale a tus seres queridos por ti por mensaje de
                texto o correo electrónico.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
